var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_svg__Icon_-_Share",
    "data-name": "Icon - Share",
    transform: "translate(-3777.253 -24.253)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "share_svg__Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 2.086,
    cy: 2.086,
    r: 2.086,
    transform: "translate(3785.825 32.825)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "share_svg__Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 2.086,
    cy: 2.086,
    r: 2.086,
    transform: "translate(3785.825 25.003)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "share_svg__Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 2.086,
    cy: 2.086,
    r: 2.086,
    transform: "translate(3778.003 28.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share_svg__Line_167",
    "data-name": "Line 167",
    transform: "translate(3781.89 27.916)",
    d: "M0 2.049L4.106 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "share_svg__Line_168",
    "data-name": "Line 168",
    transform: "translate(3781.914 32.043)",
    d: "M0 0l4.082 2.041"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCI+CiAgPGcgaWQ9Ikljb25fLV9TaGFyZSIgZGF0YS1uYW1lPSJJY29uIC0gU2hhcmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNzc3LjI1MyAtMjQuMjUzKSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzk5IiBkYXRhLW5hbWU9IkVsbGlwc2UgOTkiIGN4PSIyLjA4NiIgY3k9IjIuMDg2IiByPSIyLjA4NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzc4NS44MjUgMzIuODI1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzEwMCIgZGF0YS1uYW1lPSJFbGxpcHNlIDEwMCIgY3g9IjIuMDg2IiBjeT0iMi4wODYiIHI9IjIuMDg2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzg1LjgyNSAyNS4wMDMpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMTAxIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTAxIiBjeD0iMi4wODYiIGN5PSIyLjA4NiIgcj0iMi4wODYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM3NzguMDAzIDI4LjkxNCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTY3IiBkYXRhLW5hbWU9IkxpbmUgMTY3IiB5MT0iMi4wNDkiIHgyPSI0LjEwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzc4MS44OSAyNy45MTYpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzE2OCIgZGF0YS1uYW1lPSJMaW5lIDE2OCIgeDI9IjQuMDgyIiB5Mj0iMi4wNDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM3ODEuOTE0IDMyLjA0MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgShare as ReactComponent };